"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../../../../common/components/genericInput/GenericInput");
exports.InputField = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors, inputLabel = formData.options.inputLabel, placeholder = formData.placeholder, readOnly = formData.schema.readOnly, disabled = formData.disabled;
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var handleChange = react_1.useCallback(function (e) {
        onChange(e.target.value);
    }, [value]);
    return (<GenericInput_1.default label={label} required={required} id={id} value={value} currentError={currentError} onChange={handleChange} inputLabel={inputLabel} placeholder={placeholder} readOnly={readOnly} disabled={disabled}/>);
};
exports.default = exports.InputField;
